import type { DeepPartial } from '@luna/utils-ts';

import type { OwnTransfer } from './OwnTransfer';

export const AT: DeepPartial<OwnTransfer> = {};
